import { styled } from '@mui/material/styles';

import { SEARCH_MIN_CHARACTERS } from '~/pages/Home/constants';

type HighlightedTextProps = {
  text: string;
  query: string;
};

export default function HighlightedText({
  text,
  query,
}: Readonly<HighlightedTextProps>) {
  if (query.trim().length < SEARCH_MIN_CHARACTERS) return <>{text}</>;

  const lowerText = text.toLowerCase();
  const lowerQuery = query.toLowerCase();
  const parts: (string | React.ReactElement)[] = [];
  let lastIndex = 0;
  let index = lowerText.indexOf(lowerQuery);

  while (index !== -1) {
    if (index > lastIndex) {
      parts.push(text.slice(lastIndex, index));
    }
    parts.push(
      <StyledMark key={index}>
        {text.slice(index, index + query.length)}
      </StyledMark>,
    );
    lastIndex = index + query.length;
    index = lowerText.indexOf(lowerQuery, lastIndex);
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return <>{parts}</>;
}

const StyledMark = styled('mark')`
  background: ${({ theme }) => theme.palette.blue[100]};
  border-radius: 2px;
`;
